// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"245":"f3df9c4fcdb06afcb3c3","453":"5fd89e7d3340e90b53e8","454":"a6f5fef034e5f5b0af4c"}[chunkId] + ".js";
};